/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2024 Glowing Blue AG.
 * Authors: Davide Iadeluca, Ian Morland, Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { slug } from '../common';
import monitorPageVisits from './monitorPageVisits';
import levels from './levels';
import addUserCardInfos from './addUserCardInfos';
import achievements from './achievements';

export { default as extend } from './extend';

app.initializers.add(slug, () => {
	// ################################################################
	// Analytics
	// ################################################################
	monitorPageVisits();

	// ################################################################
	// Gamification
	// ################################################################
	levels();
	addUserCardInfos();
	achievements();

	dayjs.extend(require('dayjs/plugin/duration'));
});

// Expose compat API
import gamilyticsCompat from './compat';
import { compat } from '@flarum/core/forum';

Object.assign(compat, gamilyticsCompat);
